import { defineMessages } from "react-intl"

export default defineMessages({
    companyName: {
        id: "input.placeholder.company.name",
        defaultMessage: "Company Name",
    },
    firstName: {
        id: "input.placeholder.first.name",
        defaultMessage: "First Name",
    },
    lastName: {
        id: "input.placeholder.last.name",
        defaultMessage: "Last Name",
    },
    email: {
        id: "input.placeholder.email",
        defaultMessage: "Email Address",
    },
    phone: {
        id: "input.placeholder.phone",
        defaultMessage: "Phone Number",
    },
    password: {
        id: "input.placeholder.password",
        defaultMessage: "Password",
    },
    currentPassword: {
        id: "input.placeholder.current.password",
        defaultMessage: "Current Password",
    },
    newPassword: {
        id: "input.placeholder.new.password",
        defaultMessage: "New Password",
    },
    notSpecified: {
        id: "input.not.specified",
        defaultMessage: "Not Specified",
    },
})
